<template>
  <commonVideo />
</template>
<script>
import { provide } from "vue";
import commonVideo from "./common.vue";

export default {
  components: { commonVideo },
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    provide("msgItem", props.msgItem);
  },
};
</script>
